// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4705 ? "dc112a36" : chunkId) + "." + {"4705":"ec91fa89f5dc5218","7882":"38d88f207ee756d6"}[chunkId] + ".js";
};